import { ListItem, ListItemText, withProps } from '@cast/design-system';
import { Organization } from '@cast/types';

const OrganizationListItemText = withProps(ListItemText, {
  primaryTypographyProps: { variant: 'P12M', component: 'span' },
  secondaryTypographyProps: { variant: 'P10R' },
});

type NoOrganizationsFoundProps = {
  selectedEnterprise?: Organization;
  selectedEnterpriseChildrenCount: number;
};

export const NoOrganizationsFound = ({
  selectedEnterprise,
  selectedEnterpriseChildrenCount,
}: NoOrganizationsFoundProps) => {
  return (
    <ListItem
      multiline
      disableHover
      testId="no-organizations-found"
      sx={{
        cursor: 'default',
      }}
    >
      {selectedEnterprise ? (
        <>
          {selectedEnterpriseChildrenCount === 0 ? (
            <OrganizationListItemText
              primary="No child organizations found"
              secondary="Try creating an organization"
            />
          ) : (
            <OrganizationListItemText
              primary="No child organizations found"
              secondary="Try adjusting the filter"
            />
          )}
        </>
      ) : (
        <OrganizationListItemText
          primary="No organizations found"
          secondary="Try adjusting the filter"
        />
      )}
    </ListItem>
  );
};
